import React from 'react';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

interface ProfileMenuPopperProps {
    open: boolean;
    anchorEl: HTMLElement | null;
    onClose: () => void;
    // Add any other props you need
}

const style = {
};

const ProfileMenuPopper: React.FC<ProfileMenuPopperProps> = ({ open, anchorEl, onClose, children }) => {
    return (
        <Popper className='profile-menu-popper' open={open} anchorEl={anchorEl} placement="left-end">
            <Box sx={style}>
                {children}
            </Box>
        </Popper>
    );
};

export default ProfileMenuPopper;
